import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-HYCOT",
  "use": "icon-HYCOT-usage",
  "viewBox": "0 0 27 25",
  "content": "<symbol viewBox=\"0 0 27 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-HYCOT\">\r\n<path d=\"M3.5 3.87497H5.16667M6 3.87497H7.66667M8.5 3.87497H10.1667M26 9.64418V24H1V10.5833M4.33333 11.5416H13.7083V19.2083H4.33333V11.5416ZM1 1H26V6.75H1V1ZM17.25 11.5417L22.4583 11.5416V19.2083H17.25V11.5417Z\" stroke=\"\" stroke-width=\"2\" stroke-miterlimit=\"10\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol